import React from 'react'
import MovieCard from './MovieCard'

const MovieList = ({title,movies}) => {


  return (
    <div className='px-6'>
         <h1 className='text-2xl md:text-3xl py-4 text-white' >{title}</h1>
        <div className='flex overflow-x-scroll scrollbar-none'style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            <div className='flex'>
            {movies?.map(movie => <MovieCard key={movie.id} details={movie} />)}
          </div>
        </div>
    </div>
  )
}

export default MovieList
